<template>
    <div class="msg-view__status-bar">
        <img src="/assets/img/icons/icon-info.svg" class="msg-view__status-bar__icon">
        <p class="msg-view__status-bar__text" v-html="message"></p>
    </div>
</template>

<script>
export default {
    props: {
        contactStatus: {type: Number, default: null}
    },
    computed: {
        message() {
            switch (this.contactStatus) {
                case 2:
                    return `Din sagsbehandler er midlertidigt utilgængelig, og der kan derfor forekomme længere svartid. Hvis din henvendelse haster, er du velkommen til at skrive til os på <a href="mailto:bolig@nemadvokat.dk">bolig@nemadvokat.dk</a>.`;
                case 3:
                    return `Din sagsbehandler er midlertidigt utilgængelig, og der kan derfor forekomme længere svartid. Hvis din henvendelse haster, er du velkommen til at skrive til os på <a href="mailto:selskab@nemadvokat.dk">selskab@nemadvokat.dk</a>.`
                default:
                    return `Din sagsbehandler er midlertidigt utilgængelig, og der kan derfor forekomme længere svartid. Hvis din henvendelse haster, er du velkommen til at ringe til os på <a href="tel:+4570204161">70 20 41 61</a>.`;
            }
        }
    }
}
</script>